import { useQuery } from '@tanstack/react-query';
import { selfServiceClient } from '../services/selfService';
import { ApplicationPartType } from './types';

export const useApplicationParts = (type: ApplicationPartType, id: string) => {
  const { data = [] } = useQuery({
    queryKey: ['application-parts', type, id],
    queryFn: () =>
      selfServiceClient
        .getApplicationParts(type, id)
        .then(({ applicationParts }) => applicationParts),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  return data;
};
